import { animate, style, transition, trigger } from '@angular/animations';
import { Component, OnDestroy } from '@angular/core';
import { MatDialog, MatSnackBar } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
import { Program } from 'app/shared/models/Program';
import { ExerciseService } from 'app/shared/services/exercises.service';
import { Subject } from 'rxjs';
import { MpDialogComponent } from '../../theme/components/mp-dialog/mp-dialog.component';
import { VideoDialogComponent } from '../../theme/components/videoDialog/videoDialog.component';

@Component({
  selector: 'app-favs',
  templateUrl: './favs.component.html',
  styleUrls: ['./favs.component.scss'],
  animations: [
    trigger('box', [
      transition(':enter', [
        style({ opacity: '0', transform: 'scale(.9)' }),
        animate('.5s ease-out', style({ opacity: '1', transform: 'scale(1)' })),
      ]),
      transition(':leave', [
        style({ opacity: '1', transform: 'scale(1)' }),
        animate('.3s ease-out', style({ opacity: '0', transform: 'scale(.9)' })),
      ]),
    ]),
    trigger('placeholder', [
      transition(':enter', [style({ opacity: '0' }), animate('.5s ease-out', style({ opacity: '1' }))]),
      transition(':leave', [style({ opacity: '1' }), animate('.5s ease-out', style({ opacity: '0' }))]),
    ]),
  ],
})
export class FavsComponent implements OnDestroy {
  public favs: Program[];
  public isKids: boolean = false;
  public boxType: string;
  public counter: number = 0;

  private ngUnsubscribe: Subject<void> = new Subject<void>();

  public constructor(
    private dialog: MatDialog,
    private exerciseService: ExerciseService,
    private translate: TranslateService,
    private snackBar: MatSnackBar
  ) {
    this.exerciseService.getMyPrograms().then((programs) => (this.favs = programs));
    this.exerciseService.getModules().then((modules) => {
      if (modules) {
        let isKids = modules.some((mod) => {
          return mod.title.internal.includes('Kids');
        });

        this.isKids = isKids;
      }
    });
  }

  removeBox(p: Program) {
    //Data-Synchronization needed to update MyPrograms
    this.exerciseService
      .deleteMyProgram(p)
      .then((result) => {
        this.exerciseService.getMyPrograms().then((programs) => (this.favs = programs));
      })
      .catch((error) => {
        console.log(error);
        this.translate
          .get('EXERCISES.EDITOR.ALERT.removeError', { title: p.title })
          .takeUntil(this.ngUnsubscribe)
          .subscribe((message: string) => {
            let snackBarRef = this.snackBar.open(message, null, {
              verticalPosition: 'bottom',
              duration: 4000,
              panelClass: ['b2a-error', 'bottom'],
            });
          });
      });
  }

  editBox(box: any) {
    this.openMpDialog(box);
  }

  openMpDialog(editProgram: Program) {
    const dialogRef = this.dialog.open(MpDialogComponent, {
      panelClass: 'app-MP-dialog-container',
      // width: '70vw',
      // height: '98vh',
      position: {
        top: '2vh',
      },
      data: editProgram || {},
    });
    dialogRef
      .afterClosed()
      .takeUntil(this.ngUnsubscribe)
      .subscribe((result) => {
        this.exerciseService.getMyPrograms().then((programs) => (this.favs = programs));
      });
  }

  openVideoDialog(p: Program): void {
    const dialogRef = this.dialog.open(VideoDialogComponent, {
      panelClass: 'app-video-dialog-container',
      // width: '60vw',
      maxWidth: '1600px',
      position: {
        top: '5vh',
      },
      data: { program: p },
    });

    dialogRef.afterClosed().takeUntil(this.ngUnsubscribe).subscribe();
  }

  /**
   * On destroy cancel active subscriptions
   */
  public ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/pages/favs/favs.component.ts